module.exports = __webpack_public_path__ + "img/10785@3x.9181513d.png";